import { render, staticRenderFns } from "./onlineReview.vue?vue&type=template&id=62d4fac0&scoped=true"
import script from "./onlineReview.vue?vue&type=script&lang=js"
export * from "./onlineReview.vue?vue&type=script&lang=js"
import style0 from "./onlineReview.vue?vue&type=style&index=0&id=62d4fac0&prod&lang=scss&scoped=true"
import style1 from "./onlineReview.vue?vue&type=style&index=1&id=62d4fac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d4fac0",
  null
  
)

export default component.exports